import axios from "axios";
const authApi= process.env.REACT_APP_API_AUTH;

  export const generateTokenAppName = async (data) => {
      try {
        const response = await axios.post(`${authApi}/token/generate`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getAppNameByUsername= async (username) => {
      try {
        const response = await axios.get(`${authApi}/token/user/${username}`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getDeleteAppName= async (id) => {
      try {
        const response = await axios.delete(`${authApi}/token/${id}`);
        return response;
      } catch (error) {
        throw error;
      }
  };
